import {useRef, useState} from "react"

import UseGetterNodeValue from "../../hooks/UseGetterNodeValue";

import {Accordion} from "react-bootstrap";
import UseGetterNodeError from "../../hooks/UseGetterNodeError";
import {FiAlertTriangle} from "react-icons/fi";
import Button from "../../../form/Button";
import {DELETE, GET, PATCH, POST, PUT} from "../Webservice/Methods";
import config from "../../../../components/input/query/lookup";
import Builder from "../../../../components/input/query/builder";
import UseGetFormData from "../../../../hooks/UseGetFormData";
import Checkbox from "../../../../components/input/checkbox";
import Select from "../../../../components/input/select";
import Text from "../../../../components/input/text";
import Code from "../../../../components/input/code";
import Number from "../../../../components/input/number";


const ModalContent = (props) => {
    const formRef = useRef()
    const {onClose, fields, onSave, currentNode} = props

    const [limit, setLimit] = useState(UseGetterNodeValue(currentNode, 'settings', 'limit', ''))
    const [useLimit, setUseLimit] = useState(UseGetterNodeValue(currentNode, 'settings', 'use_limit', 'off'))
    const [wsMethod, setWsMethod] = useState(UseGetterNodeValue(currentNode, 'settings', 'method', ''))
    const [wsEndpoint, setWsEndpoint] = useState(UseGetterNodeValue(currentNode, 'settings', 'endpoint', ''))
    const [wsHeaders, setWsHeaders] = useState(UseGetterNodeValue(currentNode, 'settings', 'headers', ''))
    const [wsBody, setWsBody] = useState(UseGetterNodeValue(currentNode, 'settings', 'body', ''))
    const [useWsLimit, setUseWsLimit] = useState(UseGetterNodeValue(currentNode, 'settings', 'use_ws_limit', 'off'))


    const getError = (propertyName) => {
        return currentNode?.data?.form?.tabs?.settings?.fields?.[propertyName]?.error || null;
    };


    const handleSave = (ev) => {
        ev.preventDefault()
        const FormData = UseGetFormData(formRef)
        onSave({
            config: FormData.get('rules'),
            query: FormData.get('query'),
            use_limit: FormData.get('use_limit'),
            use_ws_limit: FormData.get('use_ws_limit'),
            limit: FormData.get('limit'),
            method: FormData.get('method'),
            endpoint: FormData.get('endpoint'),
            headers: FormData.get('headers'),
            body: FormData.get('body'),
            fields: FormData.get('fields')
        })
        onClose()
    }




    return (
        <div className="LookupWrapper">
            <div className="Window">
                <div className="WindowHeader"><span className="close" onClick={() => {
                    onClose();
                }}></span></div>
                <div className="LookupRules">

                    <div>
                        <h2>Start defining rules</h2>
                        <p>Use the component below to define the rules</p>
                    </div>

                    <form autoComplete="off" ref={formRef} onSubmit={ev => ev.preventDefault()}>
                        <Builder required
                            size="md"
                            name="rules"
                            queryName="query"
                            label="Rules"
                            isReady={true}
                            config={config({fields: fields})}
                            value={UseGetterNodeValue(currentNode, 'settings', 'config', '')}
                        />



                        <div className="d-flex" style={{marginBottom: "20px"}}>
                            <div style={{marginRight: "10px"}}>
                            <Checkbox
                                isReady={true}
                                name="use_limit"
                                value={useLimit}
                                label="Use static limit"
                                onChange={ev => {
                                    setUseLimit(ev.target.checked ? "on" : "off")
                                    if (ev.target.checked) {
                                        setUseWsLimit("off")
                                    }
                                }}
                            />
                            </div>


                            <Checkbox
                                isReady={true}
                                value={useWsLimit}
                                name="use_ws_limit"
                                label="Use ws limit"
                                onChange={ev => {
                                    setUseWsLimit(ev.target.checked ? "on" : "off")
                                    if (ev.target.checked) {
                                        setUseLimit("off")
                                    }
                                }}
                            />
                        </div>



                        {useLimit === "on" && <Number
                            name="limit"
                            label="Limit"
                            value={limit}
                            isReady={true}
                            error={getError('limit')}
                            placeholder="Provide a limit"
                        />}
                        {useWsLimit === "on" && <>

                            <Select
                                name="method"
                                label="Method"
                                isReady={true}
                                required={true}
                                value={wsMethod}
                                error={getError('method')}
                                placeholder="Choose a method"
                                options={[GET, PUT, POST, PATCH, DELETE]}
                                onChange={ev => setWsMethod(ev.value)}
                            />



                            <Text
                                isReady={true}
                                name="endpoint"
                                label="Endpoint"
                                value={wsEndpoint}
                                error={getError('endpoint')}
                                placeholder="https://api.com/v1"
                            />

                            <label className="Label">Options</label>

                            <Accordion>
                                <Accordion.Item eventKey="0">
                                    <Accordion.Header as="span">
                                        {UseGetterNodeError(currentNode, 'settings', 'headers') &&
                                            <FiAlertTriangle className="text-danger me-2"/>}
                                        Headers
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Code
                                            name="headers"
                                            tools={false}
                                            isReady={true}
                                            value={wsHeaders}
                                            error={undefined}
                                            placeholder="Json headers.."
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                                <Accordion.Item eventKey="1">
                                    <Accordion.Header as="span">
                                        {UseGetterNodeError(currentNode, 'settings', 'body') &&
                                            <FiAlertTriangle className="text-danger me-2"/>}
                                        Body
                                    </Accordion.Header>
                                    <Accordion.Body>
                                        <Code
                                            name="body"
                                            value={wsBody}
                                            tools={false}
                                            isReady={true}
                                            error={undefined}
                                            placeholder="Json body.."
                                        />
                                    </Accordion.Body>
                                </Accordion.Item>
                            </Accordion>
                        </>}


                        <div className="text-center">
                            <Button
                                type="button"
                                label="Save Rules"
                                onClick={handleSave}
                                className="btn btn-sm btn-primary mt-4"
                            />
                        </div>
                    </form>
                </div>
            </div>
        </div>
    )
}

export default ModalContent;